import { render, staticRenderFns } from "./RemocaoLancamento.vue?vue&type=template&id=c4687ee4&"
import script from "./RemocaoLancamento.vue?vue&type=script&lang=js&"
export * from "./RemocaoLancamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports